const c = (a, r) => {
  const m = {
    d: "dd",
    // Day of the month, 2 digits with leading zero
    m: "MM",
    // Month, 2 digits with leading zero
    Y: "yyyy"
    // Year, 4 digits
  }, n = {
    h: "hh",
    // Hour in 12-hour format, 2 digits with leading zero
    H: "HH",
    // Hour in 24-hour format, 2 digits with leading zero
    i: "mm",
    // Minutes, 2 digits with leading zero
    s: "ss",
    // Seconds, 2 digits with leading zero
    A: "a"
    // AM/PM marker
  }, t = (i, p) => i.split(/([ :/])/).map(
    (d) => d.split("").map((o) => p[o] || o).join("")
  ).join(""), s = t(a, n), e = t(r, m);
  return {
    timeFormat: s,
    dateFormat: e
  };
};
export {
  c as transformSioDateFormatToDatePicker
};
